import React from 'react'
import cn from 'classnames'
import { FEED_RANGE } from 'app/constants/feed'
import './styles.scss'

export const bc = 'feed-filter-by-range'
const tabs = [
  { label: 'All time', value: FEED_RANGE.all },
  { label: '30 days', value: FEED_RANGE.month },
  { label: '7 days', value: FEED_RANGE.week },
]

const FeedFilterByRange = ({ t, byRange, byTeam, setFilterByRange, fetchLeaderBoard }) => (
  <div className={bc}>
    {tabs.map((el, i) => (
      <div
        key={i}
        className={cn(`${bc}__tab`, { [`${bc}__tab-selected`]: byRange === el.value })}
        onClick={() => {
          fetchLeaderBoard({ team: byTeam, range: el.value })
          setFilterByRange(el.value)
        }}
      >
        {t(el.label)}
      </div>
    ))}
  </div>
)

export default FeedFilterByRange
